import React, { useState } from 'react';
import { Row, Col, Form, Input, Button, Alert, notification } from 'antd';

import Cluar from '../../../common/Cluar';
import _service from '@netuno/service-client';


import './index.less';

const { TextArea } = Input;

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!'
  }
};

const layout = {
  rowGutter: { gutter: [15, 0] },
  labelCol: { span: 'hide' }
};

export default ({ title }) => {

  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const handleFinish = (values) => {
    values.Newsletter.locale = window.localStorage.getItem('locale');
    setLoading(true);
    const fail = () => {
      setLoading(false);
      notification.error({
        message: title,
        description: Cluar.plainDictionary('newsletter-form-fail'),
        top: 100
      });
    };
    _service({
      url: "newsletter",
      method: 'POST',
      data: values.Newsletter,
      success: (response) => {
        if (response.json && response.json.result === true) {
          setLoading(false);
          setSent(true);
          notification.success({
            message: title,
            description: Cluar.plainDictionary('newsletter-form-success'),
            top: 100
          });
        } else {
          fail();
        }
      },
      fail: (e) => {
        console.log("Newsletter failed:", e);
        fail();
      }
    });
  };

  return (
    <section className="contact-form">
      <div className='container'>
        <Form {...layout} validateMessages={validateMessages} onFinish={handleFinish}>
          <h2 className='tittle-newsletter'>Subscribe to our Newsletter and stay up to date with all the news we have for you:</h2>
          <Row justify='start' {...layout.rowGutter}>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Form.Item {...layout.labelCol} label="Name" name={['Newsletter', 'name']}
                rules={[
                  { required: true, message: 'Insira o seu nome.' },
                  { type: 'string', message: 'Nome inválido, apenas letras minúsculas e maiúsculas.', pattern: "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$" }
                ]}>
                <Input placeholder="Name" />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Form.Item {...layout.labelCol} label="E-mail" name={['Newsletter', 'email']} rules={[{ required: true, type: 'email' }]}>
                <Input placeholder="E-mail" />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Form.Item wrapperCol={24}>
                {!sent &&
                  <Button type="primary" htmlType="submit" block {...{ loading }}>{Cluar.plainDictionary('newsletter-form-send')}</Button>}
                {sent && <Alert message={Cluar.plainDictionary('newsletter-form-alert-sent')} type="success" showIcon />}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </section >
  );
};
